// extracted by mini-css-extract-plugin
export default {"logout_btn":"logout_logout_btn__nG6OW","rtl":"logout_rtl__0qwoZ","wrapper":"logout_wrapper__ZkOTs"};